import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Checkbox, DialogActions, DialogContent, DialogTitle, ListItem, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog, CustomList } from '../../../components/StyledComponents';
import ExportDataDialog from '../UserManagement/ExportDataDialog';

const SelectDataToExportLeaveAndHolidayDialog = (props) => {
   const { t } = useTranslation();

   const [checkedItems, setCheckedItems] = useState({
      leaves: false,
      holidays: false,
   });

   const [openExportSelectedLeaveAndHoliday, setOpenExportSelectedLeaveAndHoliday] = useState(false);

   const handleOpenExportSelectedLeaveAndHoliday = () => {
      setOpenExportSelectedLeaveAndHoliday(true);
   };

   const handleCloseExportSelectedLeaveAndHoliday = () => {
      setOpenExportSelectedLeaveAndHoliday(false);
   };

   return (
      <div>
         <CustomDialog transitionDuration={300} maxWidth={'xl'} open={props.open} onClose={props.handleClose} keepMounted>
            <DialogTitle>
               <div className='flex justify-between'>
                  <div className='flex items-center gap-4'>
                     <p className='text-xl font-semibold '>Select data to export - Leaves And Holidays</p>
                  </div>
                  <GrayIconButton onClick={props.handleClose}>
                     <CloseIcon />
                  </GrayIconButton>
               </div>
            </DialogTitle>

            <DialogContent className='!py-0'>
               <div className='pt-5'>
                  <p>
                     Select the data you want to export. Selected data can be downloaded directly to your PC, or you can specify a FTP
                     location to save it.
                  </p>
                  <div className='flex flex-col'>
                     <CustomList>
                        <ListItem>
                           <Checkbox
                              id='leaves'
                              checked={checkedItems.leaves}
                              onChange={() => setCheckedItems({ ...checkedItems, leaves: !checkedItems.leaves })}
                           />
                           <ListItemText primary='Leaves' />
                        </ListItem>
                        <ListItem>
                           <Checkbox
                              id='holidays'
                              checked={checkedItems.holidays}
                              onChange={() => setCheckedItems({ ...checkedItems, holidays: !checkedItems.holidays })}
                           />
                           <ListItemText primary='Holidays' />
                        </ListItem>
                     </CustomList>
                  </div>
               </div>
            </DialogContent>

            <DialogActions>
               <div className='flex gap-2 px-4 py-4'>
                  <ControlpanelSecondaryButton onClick={props.handleClose}>
                     <CloseIcon />
                     <p>{t('button.cancel')}</p>
                  </ControlpanelSecondaryButton>
                  <ControlpanelPrimaryButton onClick={handleOpenExportSelectedLeaveAndHoliday}>
                     <PlayArrowIcon />
                     <p>{t('button.start-export')}</p>
                  </ControlpanelPrimaryButton>
               </div>
            </DialogActions>
         </CustomDialog>
         {openExportSelectedLeaveAndHoliday && (
            <ExportDataDialog onClose={handleCloseExportSelectedLeaveAndHoliday} passwordId={props.idFilePassword} />
         )}
      </div>
   );
};

export default SelectDataToExportLeaveAndHolidayDialog;
